import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import {
  FaGithub,
  FaLinkedin,
  FaFacebook,
  FaYoutube,
  FaCode,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { email } from "./DataCenter/contactDetails";

function Footer() {
  const [lastCommitDate, setLastCommitDate] = useState(null);
  const [commitCount, setCommitCount] = useState(null);

  useEffect(() => {
    fetchLastCommit();
  }, []);

  const fetchLastCommit = async () => {
    try {
      const response = await fetch(
        "https://api.github.com/repos/anmolkumarshah/data-for-portfolio/commits"
      );
      const data = await response.json();
      if (data && data.length > 0) {
        const lastCommit = data[0];
        setLastCommitDate(
          new Date(lastCommit.commit.author.date).toLocaleDateString()
        );
        setCommitCount(data.length);
      }
    } catch (error) {
      console.error("Error fetching last commit:", error);
    }
  };

  return (
    <div className="">
      <div
        id="links"
        className="max-w-[1200px] mx-auto flex flex-col sm:flex-row px-10 items-center justify-between"
      >
        <Link to="/">
          <span className="primary-color text-xl mb-4 sm:mb-0">Anmol Shah</span>
        </Link>
        <div className="flex flex-col sm:flex-row sm:space-x-4 w-full sm:w-auto text-white">
          <a
            href="https://github.com/anmolkumarshah"
            className="flex items-center space-x-2 p-2 mb-2 sm:mb-0 bg-gray-800 rounded hover:bg-gray-700"
          >
            <FaGithub />
            <span>GitHub</span>
          </a>
          <a
            href="https://www.linkedin.com/in/anmol-shah-a55694170/"
            className="flex items-center space-x-2 p-2 mb-2 sm:mb-0 bg-gray-800 rounded hover:bg-gray-700"
          >
            <FaLinkedin />
            <span>LinkedIn</span>
          </a>
          <a
            href="https://www.facebook.com/people/Anmolkumar-Shah/pfbid0oPY6tqyCTGr8u4FUrHJ3PpnwMW2DytNTZQXDpzhaBrp7dEWkfaNTtuT3Frwgn8xQl/"
            className="flex items-center space-x-2 p-2 mb-2 sm:mb-0 bg-gray-800 rounded hover:bg-gray-700"
          >
            <FaFacebook />
            <span>Facebook</span>
          </a>
          <a
            href="https://www.youtube.com/@anmolkumarshah"
            className="flex items-center space-x-2 p-2 mb-2 sm:mb-0 bg-gray-800 rounded hover:bg-gray-700"
          >
            <FaYoutube />
            <span>YouTube</span>
          </a>
          <a
            href="https://twitter.com/Anmolsh11315511"
            className="flex items-center space-x-2 p-2 mb-2 sm:mb-0 bg-gray-800 rounded hover:bg-gray-700"
          >
            <FaXTwitter />
            <span>Twitter</span>
          </a>
          <Link
            to="/memorize"
            className="flex items-center space-x-2 p-2 mb-2 sm:mb-0 bg-gray-800 rounded hover:bg-gray-700"
          >
            <FaCode />
            <span>Memorize</span>
          </Link>
        </div>
        <a href={`mailto:${email}`} className="text-white mt-4 sm:mt-0">
          {email}
        </a>
      </div>
      <div className="flex justify-center">
        {lastCommitDate && commitCount && (
          <div className="text-white mt-4 text-xs font-mono uppercase">
            Site Last Updated: {lastCommitDate} | Commits: {commitCount}
          </div>
        )}
      </div>
    </div>
  );
}

export default Footer;
